module.exports = __webpack_public_path__ + "static/media/top_bar.d0fd8405.png";